export default {"src":"/_next/static/media/writing.7a03c517.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};